<template>
<div>
    <div class="title">
        <h2 class="dp-inblock">{{programName}} - 프로그램 추가/삭제</h2>
        <button class="admin-btn-default float-right ml-10" @click="selectCopyType()">프로그램 추가</button>
        <button class="admin-btn-default float-right ml-10" @click="preview()">미리보기</button>
        <p class="w-100per">
            - 해당 수강신청의 프로그램을 추가/삭제할 수 있습니다. <br>
            - 수강신청 개요 부분의 항목은 수정 시 모든 프로그램에 전체 적용되며, 어느 프로그램을 선택하셔도 수정 가능 합니다.<br>
            - 추가된 프로그램은 수강신청의 기간에 따르며, 다르게 설정할 수 없습니다 (이 경우, 수강신청을 따로 제작해야 합니다.) <br>
            <span class="txt-red">* 프로그램 형식(Group, Untact 등)은 해당 프로그램 수정 페이지(테이블의 프로그램 명 클릭)에서 수정할 수 있습니다.</span>
        </p>
    </div>

    <div class="con w-100per mg-auto">
        <div class="state-box dp-inblock mt-50 w-100per">
            <button class="admin-btn-danger float-left" @click="delProgram()">삭제하기</button>
        </div>

        <div class="mt-20">
            <table class="admin-table-col mt-10 txt-center">
                <thead>
                    <tr>
                        <th width="50px"><input type="checkbox" v-model="allSelected" @change="allSelect()" name="" id=""></th>
                        <th width="50px">No</th>
                        <th width="150px">프로그램</th>
                        <th style="width: 100%">프로그램 명</th>
                        <th width="150px">HQ매니저</th>
                        <th width="80px">신청자</th>
                        <!-- <th width="80px">대기인원</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) of programList" :key="index">
                        <td><input type="checkbox" v-model="item.selected" @change="watchSelected()" name="" id=""></td>
                        <td>{{listLength - (50 * (pageNum - 1)) - index}}</td>
                        <td class="break-all">{{formatProgramType(item.program_type)}}</td>
                        <td class="pointer txt-blue break-all txt-left" @click="loadSugang(item.idx_program)">{{item.program_name}}</td>
                        <td>{{item.hq_name_mng}}</td>
                        <td class="txt-blue pointer" @click="moveApplyList()"><span class="bold">view</span></td>
                        <!-- <td class="txt-blue pointer" @click="moveApplyList()"><span class="bold">{{item.applicant_num}}</span>/{{item.total_fa_num}}</td>
                        <td class="txt-blue pointer" @click="moveApplyList()"><span class="bold">{{item.current_wait_num}}</span>/{{item.total_waiting_num}}</td> -->
                    </tr>

                    <!-- 리스트에 내용이 없을 경우 -->
                    <tr v-if="listLength === 0">
                        <td colspan="7" class="pt-10 pb-10">등록된 정보가 없습니다.</td>
                    </tr>

                </tbody>
            </table>
            <button class="admin-btn-default mt-10" @click="moveListMain()">이전 페이지</button>
            <div class="paging mt-30">
                <ul>
                    <li>
                        <a class="pointer" @click="prevPaging()"> &lt; </a>
                    </li>
                    <li v-for="index in calcMaxPaging()" :key="index" class="txt-blue">
                        <span class="pointer" style="padding: 8px;">
                            <a @click="paging(index)" :class="{'carrot-active bold': index === pageNum}">{{index}}</a>
                        </span>
                    </li>
                    <li>
                        <a class="pointer" @click="nextPaging()"> &gt; </a>
                    </li>
                </ul>
            </div>
        </div>
        <program-add v-if="isProgramAddModal" @close="closeModal()" @copy="copyProgram"></program-add>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
import programAdd from '@/components/fixProgram/programAdd.vue'
export default {
    components: {
        programAdd
    },
    data: () => ({
        programList: [], // 프로그램 리스트

        listLength: 0, // 신청자 인원수
        maxPagingCount: 1, // 최대 페이지 수
        maxPagePart: 1, // 최대 파트가 몇번째인지
        pagePart: 1, // 현재 페이징이 몇번째 파트에 있는지 (ex 1~10 1파트, 11~20 2파트)
        pageIdx: '', // 수강 page인덱스 (페이징 넘버랑 다른개념, 수강 자체를 구분해줌)
        pageNum: 1, // 페이징 넘버
        pageSize: 50, //  페이징 사이즈 (default: 50)

        allSelected: false, // 전체 체크
        isProgramAddModal: false, // 프로그램 추가 모달 on/off

        programName: ''
    }),

    mounted() {
        if (sessionStorage.getItem('programName')) {
            this.programName = sessionStorage.getItem('programName')
        }
        // TODO: 수강신청 관리에서 수강신청 row클릭시 가져오는 pageIdx로 교체 필요
        // this.pageIdx = this.$route.~~
        var oParams = GetUrlParams()
        this.pageIdx = oParams.pageIdx
        // this.pageIdx = 6

        this.search()
    },

    methods: {
        // 수강신청 불러오기
        async loadSugang(programIdx) {
            await this.axios.get(this.axios.root + this.axios.port + `/sugang/page/${this.pageIdx}`)
                .then(res => {
                    console.log(res)
                    if (res.data.err === 0) {
                        var pOrder = []
                        for (var i = 1; i <= 8; i++) {
                            for (var item of res.data.menu) {
                                if (item.order === i.toString()) {
                                    if (item.status === 'Y') {
                                        if (item.name === 'summary') {
                                            pOrder.push('input')
                                        } else if (item.name === 'agree') {
                                            pOrder.push('agree')
                                        } else if (item.name === 'guide') {
                                            pOrder.push('info')
                                        } else if (item.name === 'choose') {
                                            pOrder.push('enroll')
                                        } else if (item.name === 'info') {
                                            pOrder.push('userInfo')
                                        } else if (item.name === 'pay') {
                                            pOrder.push('purchase')
                                        } else if (item.name === 'complete') {
                                            pOrder.push('complete')
                                        } else if (item.name === 'popup') {
                                            pOrder.push('setPopup')
                                        }
                                    }
                                }
                            }
                        }

                        sessionStorage.setItem('pOrder', JSON.stringify(pOrder))
                        sessionStorage.setItem('category', res.data.pageInfo.category)
                        sessionStorage.setItem('pageIdx', this.pageIdx)
                        sessionStorage.setItem('programIdx', programIdx)
                        sessionStorage.setItem('fix', true)
                        sessionStorage.setItem('step', 'input')
                    }
                })
            await this.$router.push('/admin/reg/input')
        },

        // 해당 수강신청 미리보기
        preview() {
            let routeData = this.$router.resolve({
                name: 'preview-fixProgram',
                query: {
                    pageIdx: this.pageIdx
                }
            });
            window.open(routeData.href, '_blank');
        },

        // 리스트 체크박스 전체선택 / 전체해제
        allSelect() {
            for (var item of this.programList) {
                item.selected = this.allSelected
            }
        },

        // 체크박스 전체선택/전체해제시 테이블의 전체 체크박스 on/off 위함
        watchSelected() {
            var count = 0
            for (var item of this.programList) {
                if (item.selected === true) {
                    count += 1
                }
            }
            console.log('count', count)
            console.log('this.programList.length', this.programList.length)
            if (count === this.programList.length) {
                this.allSelected = true
            } else {
                this.allSelected = false
            }
        },

        // 프로그램 추가 삭제 검색
        search() {
            var params = {
                pageIdx: this.pageIdx,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }

            console.log('params', params)
            this.axios.get(this.axios.root + this.axios.port + '/program/list/', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.programList = res.data.programList
                    this.listLength = res.data.programListSize
                    this.maxPagingCount = Math.ceil(this.listLength / this.pageSize)
                    this.maxPagePart = Math.ceil(this.maxPagingCount / 10)
                    this.pagePart = Math.ceil(this.pageNum / 10)
                } else {
                    alert(res.data.result)
                    this.programList = []
                    this.listLength = 0
                }
            })
        },

        closeModal() {
            this.isProgramAddModal = false
        },

        selectCopyType() {
            var count = 0
            for (var item of this.programList) {
                if (item.selected === true) {
                    count += 1
                }
            }

            if (count === 0) {
                alert('복사하실 프로그램을 선택해주세요.')
                return false
            }
            this.isProgramAddModal = true
        },

        // 프로그램 복사하기 (내부 데이터 제외)
        async copyProgram(type) {
            console.log('type', type)
            this.isProgramAddModal = false
            var con_test = confirm("선택하신 리스트를 복사하시겠습니까?");
            if (con_test == true) {
                console.log('con_test', con_test)

                for (var item of this.programList) {
                    if (item.selected === true) {
                        // var params = {
                        //     programIdx: item.idx_program,
                        //     type: 'P'
                        // }

                        var params = new URLSearchParams()

                        params.append('programIdx', item.idx_program)
                        params.append('type', type)

                        await this.axios.post(this.axios.root + this.axios.port + '/program/copy', params)
                            .then(res => {
                                console.log('res', res)
                                if (res.data.err === 0) {
                                    alert('복사되었습니다.')
                                    this.search()
                                } else {
                                    alert(res.data.result)
                                }
                            })
                    }
                }
            } else {
                return false
            }
        },

        // 프로그램 삭제하기
        async delProgram() {
            var count = 0
            var deleteIdxs = []
            for (var item of this.programList) {
                if (item.selected === true) {
                    deleteIdxs.push(item.idx_program)
                    count += 1
                }
            }

            if (count === 0) {
                alert('삭제하실 프로그램을 선택해주세요.')
                return false
            }

            var con_test = confirm("선택하신 리스트를 삭제하시겠습니까?");
            if (con_test == true) {
                console.log('con_test', con_test)

                // var params = new URLSearchParams()
                // console.log('deleteIdxs', deleteIdxs.join('/'))
                // params.append('programIdx', deleteIdxs.join('/'))
                var params = {
                    programIdx: deleteIdxs.join('/')
                }

                await this.axios.delete(this.axios.root + this.axios.port + '/program/delete', {
                    params: params
                })
                    .then(res => {
                        console.log('res', res)
                        if (res.data.err === 0) {
                            alert(res.data.result)
                            this.search()
                        } else {
                            alert(res.data.result)
                        }
                    })
            } else {
                return false
            }
        },

        // programType 포맷 변환
        formatProgramType(type) {
            switch (type) {
                case 'G':
                    return 'Group'
                case 'L':
                    return '1:1 Language Lab'
                case 'U':
                    return 'Untact'
                case 'S':
                    return '특강'
                case 'E':
                    return '기타'
                default:
                    return '-'
            }
        },

        // 페이징
        paging(page) {
            this.pageNum = page
            this.search()
        },

        // 이전 페이징
        prevPaging() {
            if (this.pageNum === 1) {
                return false
            } else {
                this.pageNum -= 1
                this.search()
            }
        },

        // 다음 페이징
        nextPaging() {
            if (this.pageNum === this.maxPagingCount) {
                return false
            } else {
                this.pageNum += 1
                this.search()
            }
        },

        // 현재 페이지의 페이지 범위 계산
        calcMaxPaging() {
            if (this.maxPagingCount > this.pagePart * 10) {
                this.maxPagePart = this.pagePart * 10
            } else {
                this.maxPagePart = this.maxPagingCount
            }
            var pagingArray = []
            for (var i = ((this.pagePart - 1) * 10) + 1; i <= this.maxPagePart; i++) {
                pagingArray.push(i)
            }
            return pagingArray
        },

        // 신청자 리스트 페이지 이동
        moveApplyList() {
            this.$router.push(`/admin/list/applyList?pageIdx=${this.pageIdx}`)
        },

        // 이전 페이지(수강신청 관리)로 이동
        moveListMain() {
            this.$router.push('/admin/list/main')
        }
    }
}
</script>
